import { PrinterOptionsSchema } from "@redotech/redo-fulfillment-common/printer";
import * as z from "zod";

export const printReturnLabels = {
  name: "printReturnLabels" as const,
  input: z.intersection(
    z.object({
      printerId: z.number().optional(),
      printerOptions: PrinterOptionsSchema.optional(),
      printFast: z.boolean().nullish(),
      idempotencyKey: z.string().optional(),
      initiationTime: z.number().nullish(),
    }),
    z.union([
      z.object({ fulfillmentGroupIds: z.array(z.string()) }),
      z.object({ batchId: z.string() }),
    ]),
  ),
  output: z.object({
    url: z.string(),
    successIds: z.array(z.string()),
    batchFailed: z.boolean().nullish(),
    shipmentErrorMessages: z.array(z.string()).nullish(),
  }),
};

export type PrintReturnLabelsInput = z.infer<typeof printReturnLabels.input>;
